import { createSlice } from "@reduxjs/toolkit";
// utils
import axios, { API_ENDPOINTS } from "src/utils/axios";



const initialState = {
    isLoading: false,
    isSending: false,
    error: null,
    webhookList: []
};

const slice = createSlice({
    name: "webhooks",
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        stopLoading(state) {
            state.isLoading = false;
        },
        startSending(state) {
            state.isSending = true;
        },
        stopSending(state) {
            state.isSending = false;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.isSending = false;
            state.error = action.payload;
        },
        setWebhookList(state, action) {
            state.isLoading = false;
            state.webhookList = action.payload;
        },
        addWebhook(state, action) {
            state.webhookList.push(action.payload);
        },
        editWebhook(state, action) {
            const idx = state.webhookList.findIndex((w) => w.id === action.payload.id);
            if (idx !== -1) state.webhookList[idx] = action.payload;
        },
        removeWebhook(state, action) {
            state.webhookList = state.webhookList.filter((w) => w.id !== action.payload);
        },
        activateWebhook(state, action) {
            const item = state.webhookList.find((w) => w.id === action.payload);
            if (item) item.status = "active";
        }
    }
});

export default slice.reducer;

// ----------------------------------------------------------------------

export function getWebhookList() {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startLoading());
            const { status, data } = await axios.get(API_ENDPOINTS.webhook.list);
            if (status === 200) {
                dispatch(slice.actions.setWebhookList(data?.data ?? []));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

// ----------------------------------------------------------------------

export function createWebhook(payload) {
    return async (dispatch) => {
        try {
            const { status, data } = await axios.post(API_ENDPOINTS.webhook.create, {
                event_type: "API_TRACK",
                url: payload.url
            });
            if (status === 200) {
                dispatch(slice.actions.addWebhook(data.data));
                return { success: true };
            }
            return { success: false, msg: data?.msg };
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            return { success: false, msg: e?.message };
        }
    };
}

// ----------------------------------------------------------------------

export function updateWebhook(payload) {
    return async (dispatch) => {
        try {
            const { status, data } = await axios.post(API_ENDPOINTS.webhook.update, {
                id: payload.id,
                url: payload.url
            });
            if (status === 200) {
                dispatch(getWebhookList());
                return { success: true };
            }
            return { success: false, msg: data?.msg };
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            return { success: false, msg: e?.message };
        }
    };
}

// ----------------------------------------------------------------------

export function deleteWebhook(id) {
    return async (dispatch) => {
        try {
            const { status, data } = await axios.post(API_ENDPOINTS.webhook.delete, { id });
            if (status === 200) {
                dispatch(slice.actions.removeWebhook(id));
                return true;
            }
            return { success: false, msg: data?.msg };
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            return { success: false, msg: e?.message };
        }
    };
}

// ----------------------------------------------------------------------

export function sendWebhookSample(id) {
    return async (dispatch, getState) => {
        try {
            dispatch(slice.actions.startSending());
            const webhook = getState().webhooks.webhookList.find((w) => w.id === id);
            const { status, data } = await axios.post(API_ENDPOINTS.webhook.sendSample, {
                id,
                payload: webhook?.payload ?? ""
            });
            dispatch(slice.actions.stopSending());
            if (status === 200) {
                const result = data?.data;
                if (result?.success) {
                    dispatch(slice.actions.activateWebhook(id));
                }
                return { success: result?.success ?? false, payload: result?.body ?? webhook?.payload ?? null, msg: result?.success ? result?.http_status : result?.error_message };
            }
            return { success: false, msg: data?.msg };
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            return { success: false, msg: e?.message };
        }
    };
}
